<div *ngFor="let image of _albums; let i=index">
	<img [ngClass]="{'messageImg': style === 'message'}" [src]="image.thumb" (click)="open(i)" />
</div>
